import { MutationTree } from 'vuex';
import { BenutzerDetailApiDto, BenutzerInfoSearchResultApiDto } from '@/api-schema';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';
import { ITreuhandEinstellungenState } from '@/areas/treuhandadministration/store/state';

export const CLEAR_BENUTZERFILTER = 'clearBenutzerFilter';
export const APPLY_BENUTZERFILTER = 'mapBenutzerFilter';
export const LOADING_BENUTZER = 'mapBenutzerLoading';
export const MAPBENUTZERDATA = 'mapBenutzerData';
export const MAPBENUTZERDETAILS = 'mapBenutzerDetails';
export const MAPTREUHANDBENUTZERDATA = 'mapTreuhandBenutzerData';

export const mutations: MutationTree<ITreuhandEinstellungenState> = {
    [CLEAR_BENUTZERFILTER](state) {
        state.benutzerFilter = new BenutzerInfoSearchApiDto();
        state.benutzerInfoSearchResultApiDto = null;
    },
    [APPLY_BENUTZERFILTER](state, value: BenutzerInfoSearchApiDto) {
        state.benutzerFilter = value;
    },
    [LOADING_BENUTZER](state, value: boolean) {
        state.benutzerLoading = value;
    },
    [MAPBENUTZERDATA](state, benutzerInfoSearchResultApiDto: BenutzerInfoSearchResultApiDto) {
        state.benutzerInfoSearchResultApiDto = benutzerInfoSearchResultApiDto;
    },
    [MAPTREUHANDBENUTZERDATA](state, value: Array<TeilnehmerBenutzerDto>) {
        state.treuhandBenutzerData = value;
    },
    [MAPBENUTZERDETAILS](state, value: BenutzerDetailApiDto) {
        state.benutzerDetails = value;
    }
};
